export default async function checkHasLocationPermission() {
  const permissionStatus = await navigator.permissions.query({
    name: 'geolocation',
  })
  return permissionStatus.state === 'granted'
}
